import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSpring } from 'react-spring';

export const TERM_RECENT = 'View Recent Uploads';
export const TERM_LIBRARY = 'Collection';
export const TERM_LIBRARY_PLURAL = 'Collections';
export const TERM_ALBUM = 'Shoot';
export const TERM_ALBUM_PLURAL = 'Shoots';

export const hasAccess = (feature, id) => {
    // TODO: Create Has Access Check.
    console.log(feature, "VALID ACCESS");
    return true;
}


export const useAnimatedUploadedScreen = () => {
    const props = useSpring({
        to: {
            opacity: 1,
            transform: "translate3d(0,0,0)"
        },
        from: {
            opacity: 0,
            transform: "translate3d(10px,0px,0)"
        },
        delay: 0,
        config: { duration: 300 }
    })
    return {
        animatedProps: props
    }
}

export const useAnimatedAssetSelection = () => {
    const props = useSpring({
        to: {
            opacity: 1,

        },
        from: {
            opacity: 0,

        },
        delay: 0,
        config: { duration: 500 }
    })
    return {
        animatedProps: props
    }
}

export const useAnimatedFadeIn = () => {
    const props = useSpring({
        to: {
            opacity: 1,

        },
        from: {
            opacity: 0,

        },
        delay: 0,
        config: { duration: 500 }
    })
    return {
        animatedProps: props
    }
}

export const downloadFileUrl = (uri, name) => {
    var l = document.createElement("a");
    l.download = 'download';
    l.href = uri;
    l.target = '_blank'
    document.body.appendChild(l);
    l.click();
    document.body.removeChild(l);
}

export const useActiveItem = ({ id, model, selector, getAction }) => {

    const dispatch = useDispatch();
    const [activeItem, setActiveItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const store = selector();

    const findItem = () => {

        if (!store?.items) return null;
        if (!store?.items?.rows) return null;
        const found = store.items.rows.find(m => (m?.id === id));
        if (found) return found;
        return null;
    }

    useEffect(() => {
        // Clear Active Item
        setActiveItem(null);
        // Search Single Active
        if (store?.activeItem && (store.activeItem.id === id)) {
            setActiveItem(store.activeItem);
            setError(null);
            return;
        }

        // Search The Store For The Item
        const item = findItem();
        if (item) {
            setActiveItem(item);
            setError(null);
        } else {
            dispatch(getAction(id));
            setLoading(true);
        }
    }, [id])

    // Listen For Active Item Return
    useEffect(() => {
        if (store?.activeItem?.id === id) {
            setActiveItem(store.activeItem);
            setLoading(false);
            setError(null)
        } else {
            setLoading(false);
        }
    }, [loading, store?.activeItem])

    useEffect(() => {

        if (!store?.activeItemError) return;
        setError(store.activeItemError)
    }, store?.activeItemError)

    return {
        activeId: id,
        activeModel: model,
        activeItem,
        activeLoading: loading,
        setActiveItem,
        activeItemError: error
    }
}

export const useWindowSize = () => {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

export const setGlobalStorage = (key, value) => {
    if (!window?.CCStorage) window.CCStorage = {};
    window.CCStorage[key] = value;
}

export const getGlobalStorage = (key) => {
    if (!window?.CCStorage) return null;
    if (!window?.CCStorage[key]) return null;
    return window.CCStorage[key];
}